import React from 'react';
import { Grid } from '@material-ui/core';
import CardSettings from '../../components/Settings/CardSettings';
import BarcodeSettings from '../../components/Settings/BarcodeSettings';
import CardPreviewSettings from '../../components/Settings/CardPreviewSettings';

export const CardSettingsPage = () => {
  return (
    <Grid container spacing={4} style={{ padding: '2rem', width: '100%' }}>
      <Grid item xs={12} md={4}>
        <CardSettings />
      </Grid>
      <Grid item xs={12} md={4}>
        <BarcodeSettings />
      </Grid>
      <Grid item xs={12} md={4}>
        <CardPreviewSettings />
      </Grid>
    </Grid>
  );
};
